import React, { useMemo } from 'react';
import { useField } from 'formik';
import { Flex, FormField, FormHelp, IconButton, IconCopy, Input, Label } from '@zillow/constellation';
import { copyTextToClipboard } from '../../../../../../utilities/shared/copyTextToClipboard';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { clientUrls } from '../../../../../../ui-toolkit/rest/ClientUrlFactory';

export const UrlSearchStringField: React.FC = () => {
  const [field, meta] = useField<string>({ name: 'search' });

  const fullUrlToCopy = useMemo(
    () => `${window.location.origin}${clientUrls.urlFor.dashboard()}${field.value}`,
    [field.value]
  );
  return (
    <Flex display={'flex'} flexDirection={'row'} gap={'xs'}>
      <GrowFormField
        label={<Label>URL</Label>}
        required
        control={<Input {...field} autoComplete={'off'} disabled />}
        error={!!meta.error}
        description={<FormHelp>{meta.error}</FormHelp>}
      />
      <FormField
        label={<Label>&nbsp;</Label>}
        control={
          <IconButton
            type={'button'}
            title={'Copy URL'}
            icon={<IconCopy />}
            onClick={async () => {
              await copyTextToClipboard(fullUrlToCopy);
              toast('Search string copied to the clipboard', { type: 'success' });
            }}
          />
        }
      />
    </Flex>
  );
};

const GrowFormField = styled(FormField)`
  flex: 1;
`;
